import React, { useContext } from 'react'

import OptionsSelector from './OptionsSelector'
import { connect, mapDispatchToProps, mapStateToProps } from '../../../../reducers/Dispatchers'
import TitledSwitch from './TitledSwitch'
import { InstitutionOptions } from '../../../../utils/constants'
import { QuotasContext } from '../../../../Providers/Quotas/QuotasProvider'
import SearchCheckbox from '../../../antd/Selects/SearchCheckbox'
import { InstitutionContext } from '../../../../Providers/InstitutionProvider'

import '../../../../assets/quotas.scss'

export const SECTIONS_TITLE = 'Sections'
const PAUSES_TITLE = 'Pauses'
const SWITCH_TITLE = 'Display by pause'

const Settings = ({ getAppStates, selectorData, selectedSectors, t, onCheckChanged, onSectorChecked, onAllSectorsChecked, setPauseActivationState }) => {
  const { sectors } = useContext(QuotasContext)
  const { optionsMap } = useContext(InstitutionContext)

  const { pauseActivated } = getAppStates

  const handleChange = checked => {
    setPauseActivationState(checked)
  }

  return (
    <div className='flex-column h-100 w-100'>
      <SearchCheckbox
        checkAllOption
        items={sectors}
        labelKey='name'
        tooltipKey='name'
        title={t('Sectors')}
        valueKey='id'
        values={selectedSectors}
        onCheck={onSectorChecked}
        onCheckAll={onAllSectorsChecked}
      />
      {optionsMap[InstitutionOptions.QUOTA_PER_PAUSE] && (
        <TitledSwitch
          title={t(SWITCH_TITLE)}
          checked={pauseActivated}
          onChange={handleChange}
        />
      )}
      <div className='pdl-4'>
        <OptionsSelector
          treeData={selectorData ?? []}
          title={pauseActivated ? PAUSES_TITLE : SECTIONS_TITLE}
          onCheckChanged={onCheckChanged}
          checkAll
        />
      </div>
    </div>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(Settings)
